import { useTranslation } from 'react-i18next';
import { IncomeVerificationStep } from '../../../api/screening/findOverview';
import ScreeningOverviewStepTable from './ScreeningOverviewStepTable';

interface ScreeningOverviewIncomeVerificationStepTableProps {
    data: IncomeVerificationStep['data'];
}

const ScreeningOverviewIncomeVerificationStepTable = ({
    data
}: ScreeningOverviewIncomeVerificationStepTableProps) => {
    const { t } = useTranslation();

    const incomeVerificationStepData = [
        {
            subSections: [
                {
                    title: t('screening.overview.step.incomeVerification.uploadedDocuments'),
                    data: [
                        {
                            title: t('screening.overview.step.incomeVerification.bankStatements.label'),
                            value: data.bankStatements
                        }
                    ]
                },
            ]
        }
    ];

    return (
        <ScreeningOverviewStepTable
            data={incomeVerificationStepData}
        />
    );
}

export default ScreeningOverviewIncomeVerificationStepTable;
